import React from "react";

const LoaderComponent = () => {
  return (
    <div className="row justify-content-center">
      <div className="col-12">
        <div className="loading-text">Loading...</div>
      </div>
    </div>
  );
};

export default LoaderComponent;
